import React from 'react';
import { ChevronRight } from '@material-ui/icons';
import { colors } from '../../mui/colors';

export const MIconRightArrow = ({ color = colors.rightArrowColor }) => <ChevronRight style={{ color }} />;
